import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const GameRedirectPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolveSlug = async () => {
      try {
        const response = await axios.get(`${API}/game/slug/${slug}`);
        const { game_id, game_type } = response.data;
        
        // Rediriger vers la vraie page de jeu
        navigate(`/game/${game_type}/${game_id}`, { replace: true });
      } catch (error) {
        console.error('Error resolving slug:', error);
        if (error.response?.status === 404) {
          setError('Ce jeu n\'existe pas ou n\'est plus disponible.');
        } else if (error.response?.status === 400) {
          setError('Ce jeu n\'est plus actif.');
        } else {
          setError('Une erreur est survenue. Veuillez réessayer.');
        }
        toast.error('Jeu non trouvé');
      }
    };

    if (slug) {
      resolveSlug();
    }
  }, [slug, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-900 to-indigo-900 flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl p-8 max-w-md text-center shadow-2xl">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Oups !</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <a 
            href="/" 
            className="inline-block bg-gradient-to-r from-[#2E59D7] to-[#0082FB] text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg transition-shadow"
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-indigo-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-white mx-auto mb-4"></div>
        <p className="text-white text-lg">Chargement du jeu...</p>
      </div>
    </div>
  );
};

export default GameRedirectPage;
